import React, { useState } from 'react'
import GenericModal from '../../../components/modal/GenericModal';
import InputText from '../../../components/modalComponents/InputText';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { probarCorreoConvocatoriaAPI } from '../../../consumers/backendApisUrls';

// ──────────────────────────────────────────────────────────────────────────
// Modal chico "Enviar correo prueba" (paso 5 — Resumen, a pedido explícito de
// Jody 03/09/2026). Solo pide un correo electrónico y un botón "Enviar", que
// llama a ProbarCorreoConvocatoria (TrasladosPromocionesController.cs) con
// { IdConvocatoria, correoPrueba }. No hace nada más — no avanza de paso ni
// refresca la bandeja.
//
// No se reutilizó ActionGenericModal porque ese componente no permite
// capturar un input de texto del usuario (solo arma un payload fijo pasado
// por prop) y siempre llama a refreshPage, que no aplica acá.
//
// Nota: `idConvocatoria` debe venir ya seteado en formValues del wizard padre
// (NuevaConvocatoriaMasivo.jsx) — hoy eso solo ocurre editando una convocatoria
// existente (prop `detalleConvocatoria`, ver GestionTrasladosYPromociones.jsx >
// "Editar"). Crear una convocatoria nueva de punta a punta y probar el correo
// en el mismo flujo queda pendiente de que el paso 1 realmente cree el
// borrador (ver TODO de handleGuardarYContinuar).
// ──────────────────────────────────────────────────────────────────────────
const ProbarCorreoConvocatoriaModal = ({ toggleModal, idConvocatoria }) => {
    const [correoPrueba, setCorreoPrueba] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [managePostRequest] = useManagePostRequest();

    const handleChangeCorreo = (e) => {
        setCorreoPrueba(e.target.value);
    }

    const handleEnviar = () => {
        if (!correoPrueba?.trim() || isSending) return;
        setIsSending(true);
        managePostRequest(
            probarCorreoConvocatoriaAPI(),
            { IdConvocatoria: idConvocatoria, correoPrueba: correoPrueba.trim() },
            () => {
                setIsSending(false);
                toggleModal();
            },
            false,
            () => setIsSending(false),
            true
        );
    }

    return (
        <GenericModal showModal={toggleModal} titulo="Enviar correo prueba" width="500px">
            <div className="modal-body">
                <InputText label="Correo electrónico" name="correoPrueba"
                    value={correoPrueba}
                    onChange={handleChangeCorreo}
                    direction="column" isRequired />

                <div className="d-flex justify-content-center mt-3">
                    <button type="button" className="btn generic-button-buscador generic-button-hover-verde green-innova-background"
                        disabled={isSending} onClick={handleEnviar}>
                        Enviar
                    </button>
                </div>
            </div>
        </GenericModal>
    )
}

export default ProbarCorreoConvocatoriaModal
